import type {
  OrganizationId,
  ParticipantId,
  ResponseId,
  SurveyId,
  UserId,
} from "@/backend/db/drizzle/types/idTypes";
import { zodBrandedUuid } from "@/utils/helpers";
import { z } from "zod";

/** The `id` value for flags declared with `FFId.global`. */
export const GLOBAL_FLAG_ID = "global";

/** Bucketing ids. A flag declares exactly one as `id`, which becomes the PostHog distinctId. */
export const FFId = {
  userId: zodBrandedUuid<UserId>(),
  orgId: zodBrandedUuid<OrganizationId>(),
  surveyId: zodBrandedUuid<SurveyId>(),
  participantId: z.custom<ParticipantId>(
    (value) => typeof value === "string" && value.length > 0
  ),
  responseId: zodBrandedUuid<ResponseId>(),
  anonymousId: z.string().min(1).max(255),
  // For flags with no subject, such as global settings kept in a payload.
  global: z.literal(GLOBAL_FLAG_ID),
} as const;

/** Targeting inputs. Each key is also the PostHog person-property name that release conditions use. */
export const FFInput = {
  userId: FFId.userId.optional(),
  email: z.string().email(),
  isSuperAdmin: z.boolean(),
  orgId: FFId.orgId,
  surveyId: FFId.surveyId,
} as const;

export type FFInputKey = keyof typeof FFInput;
